// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1429":"116b910f","3475":"7d3f7df7","3902":"88dbbbda","7019":"126c7dfd"}[chunkId] + ".css";
};